import { useQuery, gql, type QueryHookOptions } from "@apollo/client";

const FavoriteCategoriesInfo_Shared_Query = gql`
  query FavoriteCategoriesInfo_Shared_Query($first: Int, $after: String) {
    currentStore {
      id
      name
      categories(first: $first, after: $after) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          endCursor
          startCursor
        }
        totalCount
        nodes {
          id
          name
          isVisibleToPatients
          products {
            totalCount
          }
        }
      }
    }
  }
`;

interface FavoriteCategoriesInfoData {
  currentStore: {
    name: string;
    id: string;
    categories: {
      nodes: {
        id: string;
        name: string;
        isVisibleToPatients: boolean;
        products: {
          totalCount: number;
        };
      }[];
      pageInfo: {
        endCursor: string;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor: string;
      };
      totalCount: number;
    };
  };
}

interface FavoriteCategoriesInfoVariables {
  first?: number;
  after?: string;
}

const useFavoriteCategoriesInfoQuery = (
  options?: QueryHookOptions<FavoriteCategoriesInfoData, FavoriteCategoriesInfoVariables>
) => {
  const { variables } = { variables: {}, ...options };

  return useQuery<FavoriteCategoriesInfoData, FavoriteCategoriesInfoVariables>(
    FavoriteCategoriesInfo_Shared_Query,
    {
      ...options,
      variables: { ...variables },
    }
  );
};

export type { FavoriteCategoriesInfoData, FavoriteCategoriesInfoVariables };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useFavoriteCategoriesInfoQuery, FavoriteCategoriesInfo_Shared_Query };
